import { User } from "@/types/incidents";
import { differenceInYears, parseISO } from "date-fns";

export const formatGender = (gender: string | null): string => {
  if (!gender) return "";

  return gender[0].toUpperCase() || "";
};

export const calculateAge = (dateOfBirth: string | null): number | null => {
  if (!dateOfBirth) return null;

  try {
    const dob = parseISO(dateOfBirth);
    return differenceInYears(new Date(), dob);
  } catch (error) {
    console.warn("Invalid date of birth format:", error);
    return null;
  }
};

export const formatUserInfo = (
  reportedByUser:
    | User
    | { name: string; gender?: string | null; dateOfBirth?: string | null }
): string => {
  return reportedByUser.name || "";
};
